var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-user-circle" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("watchmen.titles.list")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("div", { staticClass: "alert alert-info mb-4" }, [
            _c("h6", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.$t("watchmen.list.helper.title"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(_vm._s(_vm.$t("watchmen.list.helper.body"))),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.$t("watchmen.list.helper.linkUrl"),
                  target: "_blank",
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-external-link mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  _vm._s(_vm.$t("watchmen.list.helper.linkText")) + "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          !!_vm.watchmenToRenameCount && !!_vm.watchmenToRenameTotal
            ? _c("div", {
                staticClass: "alert alert-warning mb-3 w-fit-content",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("watchmen.list.remain_to_rename", {
                      count: _vm.watchmenToRenameCount,
                      total: _vm.watchmenToRenameTotal,
                    })
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex mb-3" },
            [
              _vm.canMerge
                ? _c(
                    "Button2",
                    {
                      attrs: { disabled: !_vm.hasDataToMerge },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleMergeModal($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("watchmen.list.merge")) +
                          "\n        "
                      ),
                      _c("span", { staticClass: "text-mono" }, [
                        _vm._v("(" + _vm._s(_vm.selectedRowsAll.length) + ")"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canMerge && _vm.selectedRowsAll.length
                ? _c(
                    "Button2",
                    {
                      staticClass: "btn-light ml-3",
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleUnselectAll($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("watchmen.list.unselect")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canCreate
                ? _c(
                    "Button2",
                    {
                      staticClass: "btn-brand ml-auto",
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleOpenNewWatchmanModal()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-plus mr-1",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("watchmen.list.add")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("SuperTable", {
            ref: "tableIdentifications",
            attrs: {
              tableColumns: _vm.tableColumns,
              tableData: _vm.tableData ? _vm.tableData : [],
              loading: !_vm.tableData,
            },
            on: { sort: _vm.handleSort, filter: _vm.handleFilter },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "modalCreate",
        attrs: { title: _vm.$t("watchmen.list.new") },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("WatchmanForm", {
                  ref: "watchmanForm",
                  model: {
                    value: _vm.newWatchmanData,
                    callback: function ($$v) {
                      _vm.newWatchmanData = $$v
                    },
                    expression: "newWatchmanData",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "Button2",
                  {
                    attrs: {
                      disabled:
                        !_vm.isNewWatchmanFormIsValid ||
                        _vm.isNewWatchmanFormIsSubmited,
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleCreateNewWatchman()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("watchmen.list.add")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "modalMerge",
        attrs: { title: _vm.$t("watchmen.list.merge") },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "FormWrapper",
                  [
                    _c("div", { staticClass: "alert alert-warning" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("watchmen.list.merge_warning")) +
                          "\n            "
                      ),
                      _c(
                        "div",
                        { staticClass: "pl-4 text-dark pb-2" },
                        _vm._l(_vm.listAllChannelsToMerge, function (channel) {
                          return _c("ChannelItem", {
                            key: channel.id,
                            staticClass: "mt-1",
                            attrs: { channel: channel },
                          })
                        }),
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("WatchmanForm", {
                      ref: "watchmanForm",
                      model: {
                        value: _vm.mergeWatchmanData,
                        callback: function ($$v) {
                          _vm.mergeWatchmanData = $$v
                        },
                        expression: "mergeWatchmanData",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "Button2",
                  {
                    attrs: { disabled: !_vm.isMergeWatchmanFormIsValid },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleMergeNewWatchman()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("watchmen.list.merge")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }